/**
 * captureDraft (VH-293) — unsaved report values across a new login.
 *
 * Before the report page opens the login it keeps what was typed but not saved
 * in this tab's sessionStorage, keyed by the session token; when the page loads
 * again it puts the draft back, then drops it. sessionStorage: the draft belongs to this
 * tab and this report only and never outlives the tab.
 */
const keyFor = (token) => `capture_draft:${token}`

export function keepDraft(token, { edits, dirty, sessionDate }) {
  try {
    const touched = {}
    dirty.forEach((id) => {
      if (edits[id] !== undefined) touched[id] = edits[id]
    })
    sessionStorage.setItem(keyFor(token), JSON.stringify({ edits: touched, sessionDate }))
  } catch {
    // Storage refused: the login still works, the values are typed again.
  }
}

/** The kept draft for ``token``, or null. Read-only: see dropDraft. */
export function peekDraft(token) {
  try {
    const raw = sessionStorage.getItem(keyFor(token))
    if (!raw) return null
    const draft = JSON.parse(raw)
    return draft && typeof draft.edits === 'object' && draft.edits !== null ? draft : null
  } catch {
    return null
  }
}

/** Forget the draft once the page has put it back. */
export function dropDraft(token) {
  try {
    sessionStorage.removeItem(keyFor(token))
  } catch {
    // Nothing to do.
  }
}
